import { z } from "zod";
import { DESCRIPTION, NAME , KIT_TYPE} from "../consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [KIT_TYPE]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
